
import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { AbstractControl, FormControl, FormGroup, Validators } from "@angular/forms";
import { IonContent, LoadingController, NavParams, Platform, PopoverController } from "@ionic/angular";
import { Navigator } from "src/app/services/routing/navigator";
import { CashierContentService } from "src/app/services/cashier/cashier-content.service";
import { CashierService } from "src/app/services/cashier/cashier.service";
import { ConfigService } from "src/app/services/config/config.service";
import { EventsService } from "src/app/services/event/event.service";
import { SuccessMessageService } from "src/app/services/message-provider/success-message.service";
import { UtilsService } from "src/app/services/utils/utils.service";
import { CashierBase } from "../../cashier-base/cashier-base";
import { DepositMainLabels } from "../cashier-models/interfaces";

import { InstantBankTransferModel } from "../cashier-models/models";
import { ProgressingComponent } from "src/app/components/progressing/progressing.component";
import { DomSanitizer } from "@angular/platform-browser";
import { RoutingService } from "src/app/services/routing/routing.service";

@Component({
  selector: "page-deposit-instant-bank-transfer",
  templateUrl: "deposit-instant-bank-transfer.html",
})
export class DepositInstantBankTransferPage extends CashierBase implements OnDestroy, OnInit {

  @ViewChild(IonContent, { static: false }) content: IonContent;
  public error = null;

  public objectKeys = Object.keys;

  // public amount: string;
  private bonusCode: string;
  private bonusID: string;

  public buttonDisabled: boolean = false;
  public showInstaDebit: boolean = false;

  public selectedBonusItem: string;

  // enroll form
  public depositForm: FormGroup;

  public defaultAmounts: any = [];
  private paymentType: any = [];
  public vendorLogoUrl: string = "";

  private inputInstaDebitAmount: AbstractControl;

  public amountSubmitted: number;

  public labels: DepositMainLabels;
  public newWindow;

  public paypalEmail = "";
  public accountsList = null;
  public loading;
  public minAmount;

  // Payment Succesfull Variables
  public params;
  public paymentRequestID;
  public customerId;
  public sessionToken;
  public safeUrl = null;
  public cards;
  public selectedCard = null;
  public isExistingCard: boolean;
  public isExistingCardList: boolean;
  public accountId = null;

  public check_deposit_complete: boolean = false;
  public check_deposit_result: string;

  public reDepositAllowed: boolean = true

  @ViewChild(ProgressingComponent) progressingUI!: ProgressingComponent;

  public subscriptionDepositSuccess;
  public subscriptionDepositFailure;
  public isMobileDevice: boolean = false;

  constructor(
    private cashierProvider: CashierService,
    private config: ConfigService,
    private contentProvider: CashierContentService,
    private events: EventsService,
    private loadingController: LoadingController,
    private navigator: Navigator,
    private navParams: NavParams,
    private platform: Platform,
    private popoverCtrl: PopoverController,
    private routing: RoutingService,
    private sanitizer: DomSanitizer,
    private successMessageService: SuccessMessageService,
    private utils: UtilsService,
  ) {
    super();

    this.labels = new InstantBankTransferModel();
    this.isMobileDevice = this.platform.is("mobile") || this.platform.is("mobileweb");
    this.bonusCode = navParams.get("bonusCode");

    this.successMessageService.clearMessage();

    if (!!this.navParams.get("bonusOffer"))
      this.bonusCode = this.navParams.get("bonusOffer");

    if (!!this.navParams.get("navigateBackPage")) {
      this.loading = this.loadingController.create({
        message: "Loading Instant Bank Transfer...",
      });

      this.loading.then((loadingDialog) => {
        loadingDialog.present();
      });
      setTimeout(() => {
        this.loading.then((loadingDialog) => {
          loadingDialog.dismiss();
        });
      }, 650);



    }
  }

  ngOnInit() {
    this.buttonDisabled = false;

    this.depositForm = new FormGroup({
      inputInstaDebitAmount: new FormControl("", [Validators.required]),
      cardList: new FormControl({ value: '', disabled: false }),
    });
    this.inputInstaDebitAmount = this.depositForm.get("inputInstaDebitAmount");


    this.onGetAccounts();
  }

  print() {
    console.log(this.depositForm);


  }
  ionViewWillEnter() {

    this.contentProvider
      .getPageConfig("instantbanktransfer")
      .then((response: DepositMainLabels) => {
        this.labels = response;
      });

    //Webservice Calls to get Credit Card Data

    this.cashierProvider.getActivePaymentTypes("PAIBT").subscribe(
      (response: any) => {
        if (response.result) {
          this.paymentType = response.payload;
          this.minAmount = this.paymentType[0].min;
          // this.onPaymentType(0);

          let i: number = 0;
          this.defaultAmounts = [];

          while (i < 11) {
            if (
              typeof this.paymentType[0]["default_amt_" + (i + 1)] !== "undefined"
            ) {
              this.defaultAmounts.push(
                this.paymentType[0]["default_amt_" + (i + 1)]
              );
            } else {
              break;
            }
            i++;
          }

          this.vendorLogoUrl = this.utils.getCDNAsset(
            "deposit/" + this.paymentType[0].image_url
          );
        }
      },
      (error) => { }
    );
  }

  selectedDepositBonusOffer($event) {
    this.bonusCode = $event.selectedbonusOffer.campaign_code;
  }

  async showLoading() {
    this.loading = await this.loadingController.create({
      message: "Loading...",
    });
    this.loading.present();
  }

  hideLoading() {
    try {
      this.loading.dismiss();
    } catch (e) { }
  }

  onSubmit() {
    let instadata: any = {};
    this.buttonDisabled = true;
    instadata.amount = this.inputInstaDebitAmount.value;
    instadata.bonusCode = this.bonusCode;
    instadata.bonusID = this.bonusID;
    instadata.currency_code = this.config.getConfig().DEFAULT_CURRENCY;
    instadata.payment_type_code = "PAIBT";
    if (this.cards[this.selectedCard] != undefined) {
      instadata.customerAccountID = this.cards[this.selectedCard].customerAccountID;
    } else if (this.accountId != null) {
      instadata.customerAccountID = this.accountId;
      this.accountId = null;
    }
    this.showLoading();
    const apiCall$ = this.cashierProvider.callDeposit(instadata)
    this.progressingUI.listenObservable(apiCall$);
    apiCall$.subscribe(
      (response: any) => {
        if (response && !!response.result) {


          this.subscriptionDepositSuccess = this.events.subscribe('event:deposit', (data) => {
            this.buttonDisabled = false;
            this.loading.dismiss();
            this.transactionClosureApproved(data);
          });

          this.subscriptionDepositFailure = this.events.subscribe('event:deposit:failed', (data) => {
            this.buttonDisabled = false;
            this.loading.dismiss();
            this.transactionClosureFailed(data);
          });

          if (response.payload.parameters?.transactionUrl) {
            this.loading.dismiss();
            this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(response.payload.parameters.transactionUrl)
            this.reDepositAllowed = true;
          }
        }
      },
      (error) => {
        this.loading.dismiss();
        this.buttonDisabled = false;
        // handle all deposit errors in base
        this.error = this.handleError(error);
        this.content.scrollToTop();
        console.error(error);
      }
    );
    return false;
  }

  get isMobile() {
    return this.platform.is("mobile") || this.platform.is("mobileweb")
      ? true
      : false;
  }

  isMobileApp() {
    return this.platform.is("cordova");
  }

  onBack = () => {
    if (!!this.navParams.get("navigateBackPage")) {
      let navigateBackPage = this.navParams.get("navigateBackPage");
      if (navigateBackPage == "default") {
        //Navigator.toLobby();
        this.navigator.navigateTo("DepositMainComponent", { multipleModals: true });
      } else if (navigateBackPage == "navbar" || navigateBackPage == "navbar-text") {
        return this.routing.defaultRoute();
      } else {
        this.navigator.navigateTo(navigateBackPage);
      }
    } else {
      this.routing.defaultRoute();
    }
  };

  onBonusSelect(index, offer) {
    this.bonusCode = offer.campaign_code;
    this.selectedBonusItem = index;

    //Deposit Event Information
    this.bonusID = offer.id;
  }

  onAmountSelected(amount) {
    this.inputInstaDebitAmount.setValue(amount);
    this.depositForm.get("inputInstaDebitAmount").markAsDirty();
    this.depositForm.get("inputInstaDebitAmount").markAsTouched();
  }

  transactionClosureApproved(data) {
    this.hideLoading();

    this.navigator.navigateTo(
      "DepositSuccessFailureComponent",
      {},
      {
        status: true,
        message: "$" + data.amount + " was deposited to your account."
      }
    );
  }

  transactionClosureFailed(data) {
    this.hideLoading();

    console.log("test failed", data.parametersMap.acct_id);
    if (data.parametersMap.acct_id && data.parametersMap.error_code == 'E302') {
      // have to be retried, cause bank MFA
      this.reDepositAllowed = false;
      this.onSubmit()
    }
    else {
      // transaction actually failed
      this.navigator.navigateTo(
        "DepositSuccessFailureComponent",
        {},
        {
          status: false,
          navigateBackPage: "DepositInstantBankTransferPage",
          message: "Your deposit transaction did not succeed.",
        }
      );
    }

  }

  public onGetAccounts() {
    this.cards = [];
    this.cashierProvider.callListAccounts().subscribe((response: any) => {
      if (response && !!response.result) {
        let tempCards: any = response.payload;
        let i = 0;

        for (let index in tempCards) {
          if (this.cardFilter(tempCards, index)) {
            tempCards[index].id = i;
            i++;
            this.cards.push(tempCards[index]);
          }
        }

        if (!!this.cards[0]) {
          this.selectedCard = 0;
          this.isExistingCardList = true;
        }
      }
    });
  }


  public cardFilter(cards, index) {
    if (cards[index].paymentTypeCode == "PAIBT") return true;
    return false;
  };

  public getCardImage(paymentTypeCode: string) {

    let imageName: string;

    for (let item in this.paymentType) {
      if (this.paymentType[item].code == paymentTypeCode) {
        imageName = this.paymentType[item].image_url;
      }
    }

    let imageURL: string = this.getPaymentImage(imageName);
    return imageURL;
  }


  public getPaymentImage(name: string): string {
    let imageUrl: string;
    imageUrl = `url(${this.utils.getDepositCDNAAsset(name)})`;
    return imageUrl;
  }

  ngOnDestroy() {
    if (this.subscriptionDepositSuccess) this.subscriptionDepositSuccess.unsubscribe();
    if (this.subscriptionDepositFailure) this.subscriptionDepositFailure.unsubscribe();
  }

}
